<script setup>
import HighlightableField from "@/components/projects/HighlightableField/HighlightableField";

defineProps({
  project: {
    type: Object,
    required: true,
  },
  candidate: {
    type: Object,
    required: true,
  },
  patent: {
    type: Object,
    required: true,
  },
  tokensEnabled: {
    type: Boolean,
    default: false,
  },
});

const getDisplayUrl = (url) => {
  if (!url) return "";
  try {
    const urlObj = new URL(url);
    return urlObj.hostname.replace("www.", "");
  } catch {
    return url;
  }
};
</script>

<template>
  <div class="mb-4 patent-item">
    <div v-if="patent.title">
      <HighlightableField
        :enabled="tokensEnabled"
        :project="project"
        :candidate="candidate"
        :token-text="patent.title"
        token-type="plain"
        :additional-token-types="['plain']"
        :similarity-tokens="[]"
      />
    </div>

    <div v-if="patent.legal" class="patent-legal">
      <HighlightableField
        :enabled="tokensEnabled"
        :project="project"
        :candidate="candidate"
        :token-text="patent.legal"
        token-type="plain"
        :additional-token-types="['plain']"
        :similarity-tokens="[]"
      />
    </div>

    <div v-if="patent.summary" class="patent-description">
      <HighlightableField
        :enabled="tokensEnabled"
        :project="project"
        :candidate="candidate"
        :token-text="patent.summary"
        token-type="plain"
        :additional-token-types="['plain']"
        :similarity-tokens="[]"
      />
    </div>

    <div v-if="patent.url" class="patent-url">
      <a :href="patent.url" target="_blank" rel="noopener noreferrer">
        <span class="material-icons-outlined md-14">link</span>
        {{ getDisplayUrl(patent.url) }}
      </a>
    </div>
  </div>
</template>

<style scoped lang="scss">
.patent-item {
  color: $tf-font-default;

  .patent-legal,
  .patent-description {
    color: $tf-font-ghost;
    margin-top: 4px;
    font-size: 14px;
  }

  .patent-url {
    margin-top: 4px;
    font-size: 14px;

    a {
      color: $blue-100;
      text-decoration: none;
      display: inline-flex;
      align-items: center;
      gap: 4px;

      &:hover {
        text-decoration: underline;
      }

      .material-icons-outlined {
        font-size: 14px;
      }
    }
  }
}
</style>
